<template>
  <el-dialog
    :title="typeTitle === 'add' ? '新增模块' : '修改模块'"
    :visible.sync="dialogVisible"
    width="520px"
    :close-on-click-modal="false"
    :before-close="handleClose"
  >
    <el-form
      ref="formRef"
      :model="form"
      :rules="sectionRules"
      label-width="110px"
    >
      <el-form-item label="板块名称" prop="title">
        <el-input v-model="form.title" placeholder="请输入板块名称"></el-input>
      </el-form-item>
      <el-form-item label="备注">
        <el-input v-model="form.comment" type="textarea" :rows="3" placeholder="请输入备注"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleSubmit">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import { getCommunityListApi,} from "@/api/publish";
  import {addFeedbackApi} from "@/api/online-survey";
  import {MessageSuccess} from "@custom/message";
export default {
      name: "layer-survey-dialog",
      data() {
        return {
            dialogVisible: false,
            typeTitle:"add",
            superUuid:"",
            form:{
              title:"",
              comment:"",
            },
            sectionRules: {
              title: [{ required: true, message: '请输入板块名称', trigger: 'blur' }]
            },
            communityList: [],
        }
    },
  props: {
    scopeOptions: { type: Array, default: () => [] }
  },
  computed: {
  },
  methods: {
    handleClose() {
      this.dialogVisible = false
      this.form ={title:"",comment:"",}
    },
    handleSubmit() {
      this.$refs.formRef.validate(valid => {
        if (valid) {
          const {title,comment, }= this.form
          let params = {
            title,comment,
            nodeType:801252,//其他
            superUuid:this.superUuid
          }
          const loading = this.$loading({lock: true, text: 'Loading', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)'});
          addFeedbackApi(params).then(res => {
              MessageSuccess('添加成功');
              this.handleClose();
             this.$emit('handleSearch');

          })
          .finally(() => loading.close());
        }
      })
    },
        async openDialog(type,row) {
            const that = this;
            console.log('row',row);
            this.superUuid = row.uuid;
            this.typeTitle = type;
            that.dialogVisible = true;
        },    
  },
  mounted() {
      getCommunityListApi().then(res => {
          this.communityList = res.list;
       });
  },
}
</script>
